import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';
/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbButtonsModule, NgbDropdownModule, NgbTabsetModule, NgbTooltipModule, NgbModalModule, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import { MultiSelectService } from './service/multi-select.service';
import { NavigateTopService } from './service/navigate-top.service';
import { HttpClientModule } from '@angular/common/http';
import { ConfigService } from './service/config.service';
import { EndpointsService } from './service/endpoints.service';
import { BackendApiService } from './service/backendapi.service';
import { MasterDataService } from './service/master-data.service';
import { DataCachingService } from './data-caching.service';
import { ComboBoxValidatorService } from './service/validator.service';
import { MatButtonModule } from '@angular/material/button';
import { DataSharingService } from "./service/data-sharing.service";
import { MsalApplicationModule } from './msal-application/msal-application.module';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { BarComponent } from './segment/bar/bar.component';
import { CampaignComponent } from './segment/campaign/campaign.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ExecDashComponent } from './exec-dash/exec-dash.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { MatIconModule, MatListModule, MatTooltipModule, MatDialogModule, MatFormFieldModule, MatMenuModule, MatTableModule, MatSelectModule } from '@angular/material';
import { CheckBoxModule, ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TarriffModule } from './tarriff/tarriff.module';
import { BlacklistModule } from './blacklist/blacklist.module';
import { WhitelistModule } from './whitelist/whitelist.module';
import { BusinessRulesComponent } from './business-rules/business-rules.component';
import { NgBootstrapDatetimeAngularModule } from "ng-bootstrap-datetime-angular";
import { DataTablesModule } from 'angular-datatables';
import { CommunityComponent } from './community/community.component';
import { DeleteCampaignDialogComponent } from './segment/delete-campaign-dialog/delete-campaign-dialog.component';
import { ReportsModule } from './reports/reports.module';
import { RoamersModule } from './segment/roamers.module';
import { SubscriberInfoModule } from './subscriber-info/subscriber-info.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { CountryCodesService } from './service/country-codes.service'
import { BussinessRulesDataTableComponent } from './business-rules/bussiness-rules-data-table/bussiness-rules-data-table.component';
import { AddBussinessRulesComponent } from './business-rules/add-bussiness-rules/add-bussiness-rules.component';
import { CommonModulesForCountriesComponent } from './commonModulesForCountries/common-modules-for-countries/common-modules-for-countries.component';
import { CampaignDataTableComponent } from './segment/campaign/campaign-data-table/campaign-data-table.component';
import { AddCampaignComponent } from './segment/campaign/add-campaign/add-campaign.component';
import { RrmsDashboardComponent } from './dashboard/rrms-dashboard/rrms-dashboard.component';
import { DashboardModule } from './dashboard/dashboard.module';
import HC_exportData from 'highcharts/modules/export-data';
import { NetworkAdditionModule } from './network-addition/network-addition.module';
import { CommunityTableDataComponent } from './community-table-data/community-table-data.component';


@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavRightComponent,
    ToggleFullScreenDirective,
    ConfigurationComponent,
    BarComponent,
    CampaignComponent,
    ExecDashComponent,
    AddBussinessRulesComponent,
    BusinessRulesComponent,
    BussinessRulesDataTableComponent,
    CommunityComponent,
    CommunityTableDataComponent,
    DeleteCampaignDialogComponent,
    CommonModulesForCountriesComponent,
    CampaignDataTableComponent,
    AddCampaignComponent,
    CommunityTableDataComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    TarriffModule,
    BlacklistModule,
    WhitelistModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbTabsetModule,
    NgbModalModule,
    HttpClientModule,
    MatButtonModule,
    HighchartsChartModule,
    MsalApplicationModule.forRoot('./assets/data/msal-config.json'),
    ChartsModule,
    HighchartsChartModule,
    NgbDatepickerModule,
    DataTablesModule,
    NgBootstrapDatetimeAngularModule,
    Ng4LoadingSpinnerModule.forRoot(),
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    NgMultiSelectDropDownModule.forRoot(),
    MultiSelectAllModule,
    CheckBoxModule,
    ButtonModule,
    NumericTextBoxModule,
    Ng4LoadingSpinnerModule.forRoot(),
    MatMenuModule,
    SharedModule,
    NgbModule,
    DataTablesModule,
    MatTableModule,
    ReportsModule,
    MatSelectModule,
    RoamersModule,
    DashboardModule,
    SubscriberInfoModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NetworkAdditionModule
  ],
  entryComponents: [DeleteCampaignDialogComponent, AddBussinessRulesComponent,AddCampaignComponent],
  providers: [
    NavigationItem,
    MultiSelectService,
    NavigateTopService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: DataCachingInterceptor,
    //   multi: true
    // },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [
        ConfigService,
        MasterDataService
      ],
      useFactory: (appConfigSvc: ConfigService) => {
        return () => {
          return appConfigSvc.loadConfig();
        };
      }
    },
    // {
    //   provide: APP_INITIALIZER,
    //   multi: true,
    //   deps: [
    //     ConfigService
    //   ],
    //   useFactory: (appConfigSvc: ConfigService) => {
    //     return () => {
    //       return appConfigSvc.loadCountry();
    //     };
    //   }
    // },
    CountryCodesService,
    DataCachingService,
    ConfigService,
    EndpointsService,
    BackendApiService,
    MasterDataService,
    ComboBoxValidatorService,
    DataSharingService,
    ThemeService,

  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
